var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.32 11.5L8.32 4.5",
    id: "f6pl2RLxTG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32 11.5L5.32 8.5",
    id: "i2XHB1iEV"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.32 8.5L8.32 11.5",
    id: "eiMlFIEuN"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f6pl2RLxTG",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f6pl2RLxTG",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#4050a6",
    strokeWidth: 1.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i2XHB1iEV",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i2XHB1iEV",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#4050a6",
    strokeWidth: 1.3,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eiMlFIEuN",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eiMlFIEuN",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#4050a6",
    strokeWidth: 1.3,
    strokeOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.ce43a4e7e4a05d620e51bb7ac367513f.svg";
export { ForwardRef as ReactComponent };